// extracted by mini-css-extract-plugin
module.exports = {"block":"DepartmentBlock_block__f9Qia","departmentName":"DepartmentBlock_departmentName__1-ka4","department":"DepartmentBlock_department__1RsCK"};